import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchClients = createAsyncThunk('clients/fetch', async (params = {}) => {
  const { data } = await api.get('/clients/', { params });
  return data;
});
export const fetchClient = createAsyncThunk('clients/fetchOne', async (id) => {
  const { data } = await api.get(`/clients/${id}/`);
  return data;
});
export const createClient = createAsyncThunk('clients/create', async (payload, { rejectWithValue }) => {
  try {
    const { data } = await api.post('/clients/', payload);
    return data;
  } catch (e) {
    const errData = e.response?.data;
    // Si le serveur renvoie du HTML (page d'erreur Django debug), extraire le message
    if (typeof errData === 'string' && errData.includes('<!DOCTYPE')) {
      return rejectWithValue({ __html__: `Erreur serveur ${e.response?.status || ''}. Vérifiez que la migration a été appliquée (python manage.py migrate).` });
    }
    return rejectWithValue(errData || { __reseau__: 'Impossible de contacter le serveur. Vérifiez que le backend est démarré.' });
  }
});
export const updateClient = createAsyncThunk('clients/update', async ({ id, payload }, { rejectWithValue }) => {
  try {
    const { data } = await api.patch(`/clients/${id}/`, payload);
    return data;
  } catch (e) { return rejectWithValue(e.response?.data); }
});
export const archiverClient = createAsyncThunk('clients/archiver', async (id) => {
  const { data } = await api.post(`/clients/${id}/archiver/`);
  return { id, ...data };
});
export const activerClient = createAsyncThunk('clients/activer', async (id) => {
  const { data } = await api.post(`/clients/${id}/activer/`);
  return { id, ...data };
});

const clientsSlice = createSlice({
  name: 'clients',
  initialState: { liste: [], client: null, pagination: {}, loading: false, error: null },
  reducers: { clearClient: (s) => { s.client = null; } },
  extraReducers: (b) => {
    b.addCase(fetchClients.pending,   (s) => { s.loading = true; })
     .addCase(fetchClients.fulfilled, (s, { payload }) => {
       s.loading = false;
       s.liste = payload.results || payload;
       s.pagination = { count: payload.count, next: payload.next, previous: payload.previous };
     })
     .addCase(fetchClients.rejected,  (s) => { s.loading = false; })
     .addCase(fetchClient.pending,    (s) => { s.loading = true; s.client = null; })
     .addCase(fetchClient.fulfilled,  (s, { payload }) => { s.loading = false; s.client = payload; })
     .addCase(createClient.fulfilled, (s, { payload }) => { s.liste.unshift(payload); })
     .addCase(updateClient.fulfilled, (s, { payload }) => {
       s.client = payload;
       const idx = s.liste.findIndex(c => c.id === payload.id);
       if (idx !== -1) s.liste[idx] = payload;
     });
  },
});
export const { clearClient } = clientsSlice.actions;
export default clientsSlice.reducer;
